import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {Sl3AnagrafService} from '../../general-services/service-sl3-anagraf/sl3-anagraf.service';
import {L1Model} from '../../../models/L1Model';
import * as toastr from 'toastr';
import {Router} from '@angular/router';
import {LoaderService} from '../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-l1-anagraf',
  templateUrl: './sl3-anagraf.component.html',
  styleUrls: ['./sl3-anagraf.component.scss']
})
export class Sl3AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  displayedColumns: Array<string>;
  dataSource: any;
  l1Url: string;
  isMocked: boolean;
  isAnagraphSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  pageSize: number;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;

  @Output() elementSelected = new EventEmitter();

  filter: L1Model;



  constructor(private sl3AnagrafService: Sl3AnagrafService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.isAnagraphSection = ProjectConstants.returnIsAnagraphSection(this.router.url);
    this.l1Url = servers.apiUrl + urls.cobidbService + urls.sl3;
    this.showActions = true;
    this.selectedRowIndex = -1;
    this.filter = new L1Model();
  }

  ngOnInit() {
    this.isMocked = false;
    if (this.showActions === true) {
      this.displayedColumns = ['L1Cod', 'l1Desc', 'inArchStructSett', 'actions'];
    } else {
      this.selectedRowIndex = this.idSelected;
      this.displayedColumns = ['L1Cod', 'l1Desc'];
    }

    this.pageSize = +this.PAGINATOR.PAGE_SIZE_ARRAY[0];


    this.setOffsetInSession();
    this.getAll(this.offset);
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    if (this.isMocked) {
      this.listData = new MatTableDataSource(this.dataSource);
      this.listData.paginator = this.paginator;
      this.listData.sort = this.sort;
    } else {
      this.getPageSubscribe = this.sl3AnagrafService.getPage(offset, this.filter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    }
  }
  filterTable() {
    this.getAll(new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0));
  }

  resetTable() {
    this.filter = new L1Model();
    this.getAll(new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0));
  }
  openDialog(id: number) {
    const layerData = this.dataSource.find(data => data.id === id) as L1Model;
    const list: GenericArray[] = [
      { id: 'SL3 Cod', value: layerData.cod.toString() },
      { id: 'SL3 Description', value: layerData.description.toString() }
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.sl3AnagrafService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('L1 with id ' + id + ' was deleted with success', 'Success');

              this.getAll(this.offset);
            } else {
              toastr.info('L1 cannot be deleted', 'Alert');
            }

          }, error => {
            toastr.error('L1 with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.dataSource = dataFiltered.content;
    this.listData = new MatTableDataSource(this.dataSource);
    this.paginator.pageIndex = this.offset.pageIndex;
    this.paginator.length = dataFiltered.totalElements;

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('sl3Offset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('sl3Offset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      this.pageSize = this.offset.pageSize;
    }
  }
}
